import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { PandoraTypes } from '../../constants/SourceTypes';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDominantColor } from '../../lib/ArtUtils';
import * as CapabilitiesUtils from '../../lib/CapabilitiesUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';
import PodcastEpisodeMetadata from '../PodcastEpisodeMetadata/PodcastEpisodeMetadata';

import CatalogRowItem from './CatalogRowItem';

/**
 * PodcastEpisodeRowItem is for rendering T3 podcast episode row items.
 *
 * See CatalogRowItem and lib/GridItem for additional available props.
 */
class PodcastEpisodeRowItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    index: PropTypes.number,
    blankItem: PropTypes.bool,
    mainText: PropTypes.string,
    mainTextUrl: PropTypes.string,
    programName: PropTypes.string,
    imgUrl: PropTypes.string,
    dominantColor: PropTypes.string,
    isExplicit: PropTypes.bool,
    isPlayingCurrently: PropTypes.bool,
    isPaused: PropTypes.bool,
    episodeDuration: PropTypes.number,
    elapsedTime: PropTypes.number,
    releaseDate: PropTypes.string,
    isFinished: PropTypes.bool,
    isMixedWithOtherSources: PropTypes.bool,
    showCollectedBadge: PropTypes.bool,
    showDescription: PropTypes.bool,
    sourceCardMenuItems: PropTypes.array,
    isClickableRow: PropTypes.bool,
    isMobileDevice: PropTypes.bool,
  };

  static defaultProps = {
    pandoraType: PandoraTypes.EPISODE,
  };

  getEpisodeMetadataProps() {
    const { episodeDuration, releaseDate, elapsedTime, isFinished } = this.props;
    return {
      episodeDuration,
      releaseDate,
      elapsedTime,
      isFinished,
    };
  }

  getSecondText() {
    const { showDescription, programName, releaseDate } = this.props;
    return showDescription ? <PodcastEpisodeMetadata releaseDate={releaseDate} /> : programName;
  }

  getThirdText() {
    return <PodcastEpisodeMetadata {...this.getEpisodeMetadataProps()} />;
  }

  getRightColText() {
    const { showDescription, isMixedWithOtherSources, releaseDate } = this.props;
    return (
      <PodcastEpisodeMetadata
        {...this.getEpisodeMetadataProps()}
        showSourceName={isMixedWithOtherSources}
        releaseDate={!showDescription && releaseDate}
      />
    );
  }

  render() {
    const { isClickableRow, mainTextUrl, isMobileDevice } = this.props;

    return (
      <CatalogRowItem
        rightColChild={!isClickableRow && this.getRightColText()}
        rowUrl={isClickableRow && mainTextUrl}
        secondText={this.getSecondText()}
        thirdText={isClickableRow && this.getThirdText()}
        noHover={!isClickableRow && isMobileDevice}
        isFullRowLink={!isClickableRow && isMobileDevice}
        onlyShowRightColPlay={!isClickableRow && isMobileDevice}
        hideLeftCol={!isClickableRow && isMobileDevice}
        {...this.props}
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const details = getAnnotationsById(state, ownProps.id);
  props.blankItem = !details;

  if (details && ownProps.id) {
    const progressDetails = getInDomain('playback.utils.getPodcastEpisodeProgressById', null)(
      state,
      ownProps.id,
    );
    const backstageUrl = details.get('shareableUrlPath');
    const elapsedTime = progressDetails ? progressDetails.get('elapsedTime') : 0;
    props.mainText = details.get('name');
    props.mainTextUrl = backstageUrl;
    props.programName = details.get('programName');
    props.releaseDate = details.get('releaseDate');
    props.episodeDuration = details.get('duration');
    props.imgUrl = getArt(details, 90, state, PandoraTypes.EPISODE);
    props.dominantColor = getDominantColor(details);
    props.isExplicit = getInDomain('catalog.utils.isExplicit')(details);
    props.isPlayingCurrently = getInDomain('playback.utils.isTrackPlayingCurrently', false)(
      state,
      ownProps.id,
    );
    props.isPaused =
      !getInDomain('playback.utils.isAudioPlaying')(state) && props.isPlayingCurrently;
    props.elapsedTime = props.isPlayingCurrently && !props.isPaused ? 0 : elapsedTime;
    props.isFinished = progressDetails && progressDetails.get('isFinished');
    props.description = ownProps.showDescription && details.get('summary');
    props.isCollected =
      ownProps.showCollectedBadge &&
      getInDomain('collection.utils.isPandoraIdInCollection', false)(state, ownProps.id);
    props.isMobileDevice = CapabilitiesUtils.isMobileDevice(state);

    props.sourceCardMenuItems = getSourceCardMenuItems({
      state,
      pandoraId: ownProps.id,
      pandoraType: PandoraTypes.EPISODE,
      podcastEpisodeData: {
        canDelete: ownProps.isThumbed,
      },
    });
  }
  return props;
}

export default connect(mapStateToProps)(PodcastEpisodeRowItem);
